import { RefObject, useLayoutEffect } from 'react';

const writeCssPixelVariable = (element: HTMLElement, name: string, value: number) => {
  const nextValue = `${value}px`;
  if (element.style.getPropertyValue(name) === nextValue) return;
  element.style.setProperty(name, nextValue);
};

/**
 * Mirrors the sticky header's measured heights onto CSS custom properties, so the stylesheet
 * can slide the collapsible part out of view and offset scroll anchors even when a filter-tag
 * row or date strip changes the header's height.
 */
export const useListHeaderMetrics = (
  headerRef: RefObject<HTMLElement | null>,
  collapsibleRef: RefObject<HTMLElement | null>,
  targetRef: RefObject<HTMLElement | null>,
): void => {
  useLayoutEffect(() => {
    const header = headerRef.current;
    const collapsible = collapsibleRef.current;
    const target = targetRef.current;
    if (!header || !collapsible || !target) return;

    writeCssPixelVariable(target, '--list-header-height', header.offsetHeight);
    writeCssPixelVariable(target, '--list-header-collapsible-height', collapsible.offsetHeight);
  });
};
